import type { NextPage } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { defaultLanguage } from "../../config/LanguageConfiguration";
import { NWONPage } from "../../config/NWONPage";
import CodeImage from "../../public/media/services/code.jpeg";
import { SlideInformation } from "../../src/components/02-molecules/NWONHeroSlider/NWONHeroSliderInterfaces";
import NWONHeroSection from "../../src/components/03-organisms/NWONHeroSection/NWONHeroSection";
import NWONServicesSection from "../../src/components/03-organisms/NWONServicesSection/NWONServicesSection";
import { NWONInitial } from "../../src/components/NWONInitial/NWONInitial";
import { isLanguage } from "../../src/helpers/general/isLanguage";
import { defaultNameSpaces } from "../../src/i18n/i18n-namespaces";
import { GetStaticPropsDefault } from "../../src/interfaces/GetStaticPropsDefault";

const carouselElements: SlideInformation[] = [{ image: CodeImage }];

const ServicePage: NextPage = () => {
  const { t } = useTranslation<"pages">("pages");

  return (
    <NWONInitial pageInformationData={{ page: NWONPage.Services }}>
      <NWONHeroSection
        title={t("service.heroSection.title")}
        subtitle={t("service.heroSection.description")}
        slideInformation={carouselElements}
      />

      <NWONServicesSection title={t("homepage.servicesSection.title")} />
    </NWONInitial>
  );
};

export const getStaticProps: GetStaticPropsDefault = async (context) => {
  const locale = isLanguage(context.locale) ? context.locale : defaultLanguage;

  return {
    props: {
      ...(await serverSideTranslations(
        locale,
        defaultNameSpaces.concat(["service", "serviceDetailPage"])
      )),
    },
  };
};

export default ServicePage;
